import { StockWithVariant } from "@/api/daily-stock-api";
import { StockStats } from "./type";

export function StockMovementInfo({
  stock,
}: {
  stock: StockWithVariant;
  stats: StockStats;
}) {
  const stockInHand = stock.stockInHand ?? 0;
  const soldQty = stock.soldQty ?? 0;

  return (
    <div className="space-y-1 min-w-0 max-w-full">
      <div className="space-y-1.5">
        {/* Stock in Hand */}
        <div className="flex items-center justify-between space-x-1 md:space-x-2 min-w-0">
          <div className="flex items-center space-x-1 md:space-x-1.5 min-w-0 flex-shrink">
            <div
              className={`w-2 h-2 rounded-full shrink-0 ${stockInHand > 0
                  ? "bg-blue-500"
                  : stockInHand === 0
                    ? "bg-orange-500"
                    : "bg-red-500"
                }`}
            ></div>
            <span
              className={`text-xs font-medium truncate ${stockInHand > 0
                  ? "text-blue-700"
                  : stockInHand === 0
                    ? "text-orange-700"
                    : "text-red-700"
                }`}
            >
              Stock in Hand
            </span>
          </div>
          <div className="flex items-center space-x-0.5 md:space-x-1.5 flex-shrink-0">
            <span className="text-xs font-bold text-slate-900 whitespace-nowrap">
              {stockInHand.toLocaleString()}
            </span>
            {stock.receiveQty > 0 && (
              <span className="inline-flex items-center px-1 md:px-1.5 py-0.5 rounded-md text-xs font-medium bg-green-100 text-green-700 whitespace-nowrap">
                +{stock.receiveQty.toLocaleString()}
              </span>
            )}
            {stock.adjustInQty > 0 && (
              <span className="inline-flex items-center px-1 md:px-1.5 py-0.5 rounded-md text-xs font-medium bg-green-100 text-green-700 whitespace-nowrap">
                +{stock.adjustInQty.toLocaleString()}
              </span>
            )}
            {stock.adjustOutQty > 0 && (
              <span className="inline-flex items-center px-1 md:px-1.5 py-0.5 rounded-md text-xs font-medium bg-red-100 text-red-700 whitespace-nowrap">
                -{stock.adjustOutQty.toLocaleString()}
              </span>
            )}
          </div>
        </div>

        {/* Sold */}
        <div className="flex items-center justify-between space-x-2">
          <div className="flex items-center space-x-1.5">
            <div className="w-2 h-2 rounded-full bg-green-500"></div>
            <span className="text-xs text-green-700 font-medium">
              Sold
            </span>
          </div>
          <span className="text-xs font-bold text-slate-900 whitespace-nowrap flex-shrink-0">
            {soldQty.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
}
